import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { sso } from '@/api/rest';
import { partner_center_url } from '@/common/env';

interface SSOVariables {
  shop_id: string;
  redirect_to: string;
}

type Options = UseMutationOptions<void, unknown, SSOVariables>;

export const useSSOMutation = (options?: Options) => {
  const { isPending: is_loading, ...rest } = useMutation({
    ...options,
    mutationKey: ['sso'],
    mutationFn: async ({ redirect_to, shop_id }: SSOVariables) => {
      const token = await sso({ shop_id });

      const is_exist_token = token && token.length > 0;

      if (is_exist_token) {
        const search = new URLSearchParams();
        search.set('token', token);
        search.set('redirect_to', redirect_to);
        window.open(`${partner_center_url}/api/provider/access/sso?${search}`, '_blank', 'noreferrer noopener');
      }
    },
  });

  return {
    ...rest,
    is_loading,
  };
};
